import React, { memo } from 'react';
import PropTypes from 'prop-types';
import StateTransitionUserGroupItemComponent from './StateTransitionUserGroupItemComponent';

const StateTransitionUserGroupListComponent = ({ stateTransition, userGroups, dispatch, changedStateTransitionsPermission }) => {
  return userGroups.map(userGroup => {
    return (
      <StateTransitionUserGroupItemComponent
        key={userGroup.id}
        userGroup={userGroup}
        stateTransition={stateTransition}
        dispatch={dispatch}
        changedStateTransitionsPermission={changedStateTransitionsPermission[userGroup.id]}
      />
    );
  });
};

StateTransitionUserGroupListComponent.propTypes = {
  stateTransition: PropTypes.object.isRequired,
  userGroups: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  changedStateTransitionsPermission: PropTypes.object.isRequired
};

export default memo(StateTransitionUserGroupListComponent);
